import '@vkontakte-internal/fonts/vk-sans-display/index.css';
import '@vkontakte/vkui/dist/vkui.css';
import { useLoadLangConfig } from './hooks';
import { AppProvider } from './contexts';
import { RootView } from './components';
import './index.css';

export function App() {
  const { isLangConfigLoading } = useLoadLangConfig();

  return (
    <AppProvider isLangConfigLoading={isLangConfigLoading}>
      <RootView />
    </AppProvider>
  );
}
